import { Controller } from "@hotwired/stimulus"

// Opens the recipe preview modal and loads the preview frame
export default class extends Controller {
  static values = {
    url: String,
    modal: String,
    frame: String
  }

  connect() {
    this.modalConstructor = null
  }

  show(event) {
    event.preventDefault()

    const frameId = this.frameValue
    const url = this.urlValue

    if (frameId && url) {
      const frame = document.getElementById(frameId)
      if (frame) {
        frame.innerHTML = this.loadingMarkup()
        frame.setAttribute("src", url)
      }
    }

    this.openModal()
  }

  loadingMarkup() {
    return `
      <div class="py-5 text-center text-muted">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-3 mb-0">Loading recipe details…</p>
      </div>
    `
  }

  async openModal() {
    if (!this.modalValue) return

    const modalElement = document.getElementById(this.modalValue)
    if (!modalElement) return

    if (modalElement.parentElement !== document.body) {
      document.body.appendChild(modalElement)
    }

    let ModalClass = this.resolveModalConstructor()

    if (!ModalClass) {
      try {
        const module = await import("bootstrap/js/dist/modal")
        ModalClass = module.default || module.Modal || module
        this.modalConstructor = ModalClass
      } catch (error) {
        console.error("RecipePreviewController: unable to load Bootstrap modal", error)
        return
      }
    }

    if (!ModalClass || typeof ModalClass.getOrCreateInstance !== "function") {
      return
    }

    ModalClass.getOrCreateInstance(modalElement).show()
  }

  resolveModalConstructor() {
    if (this.modalConstructor) {
      return this.modalConstructor
    }

    if (window.bootstrap?.Modal) {
      this.modalConstructor = window.bootstrap.Modal
    } else if (window.Bootstrap?.Modal) {
      this.modalConstructor = window.Bootstrap.Modal
    } else if (typeof bootstrap !== "undefined" && bootstrap.Modal) {
      this.modalConstructor = bootstrap.Modal
    }

    return this.modalConstructor
  }
}

